// Check if email is valid
const isValidEmail = (email) => {
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  return emailRegex.test(email);
};

// Checks validity of username only containing:
// lower case letters, digits 0 to 9
// and underscores.
const isValidUsername = (username) => {
  if (username.length < 1) {
    return false;
  }
  const usernameRegex = /^[a-zA-Z0-9_]+$/;
  return usernameRegex.test(username);
};

// Check validity of passowrd containing:
// minimum length of 6 characters
// at least one upper case letter
// at least one lower case letter
// at least one number
const isValidPassword = (password) => {
  if (password.length < 6) {
    return false;
  }
  // Developer note: ?= is called "positive lookahead assertions" for regex
  const passwordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])/;
  return passwordRegex.test(password);
};

// Check if the two passwords entered are matching
const isMatchingPasswords = (password, passwordCopy) => {
  if (password === passwordCopy) return true;
  return false;
};

export { isValidEmail, isValidUsername, isValidPassword, isMatchingPasswords };
